"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("element-closest");
var SimpleToggle_1 = __importDefault(require("./SimpleToggle"));
var MobileMenuToggle = (function () {
    function MobileMenuToggle() {
        var _this = this;
        this.header = document.querySelector('header.mobile');
        this.toggle = this.header.querySelector('.menu-toggle');
        this.asideMenu = this.header.querySelector('.aside-menu');
        this.searchToggle = document.querySelectorAll('.search-toggle');
        this.searchToggleCount = this.searchToggle.length;
        for (var i = 0; i < this.searchToggleCount; ++i) {
            this.searchToggle.item(i).addEventListener('click', function (e) {
                _this.toggle.classList.remove('show');
                if (_this.asideMenu) {
                    _this.asideMenu.classList.remove('show');
                }
            });
        }
        new SimpleToggle_1.default('.menu-toggle', '.aside-menu', {
            buttonToggleClassName: 'show',
            targetToggleClassName: 'show'
        });
    }
    MobileMenuToggle.getInstance = function () {
        if (!this.instance) {
            this.instance = new MobileMenuToggle();
        }
        return this.instance;
    };
    return MobileMenuToggle;
}());
exports.default = MobileMenuToggle;
